import './IconArrow.scss';

import * as React from 'react';

type Props = {
  direction: 'left' | 'right';
  size: number;
  pathClassName?: string;
};

export default class Arrow extends React.Component<Props> {
  static defaultProps = {
    direction: 'left',
    size: '40',
  };

  render() {
    const { direction, size, pathClassName } = this.props;

    return (
      <svg
        height={`${size}px`}
        width={`${(size * 46) / 40}px`}
        viewBox="0 0 46 40"
        className="IconArrow"
      >
        <g
          className={`IconArrow-path ${pathClassName}`}
          transform={` ${
            direction === 'right' ? 'rotate(180, 23, 20)' : ''
          } translate(3, 3)`}
          strokeWidth="3"
        >
          <path d="M0,17 L42.253906,17"></path>
          <g strokeLinecap="square">
            <path d="M0,17 L16.7242697,0.275730299"></path>
            <path
              d="M0,34 L17,17"
              transform="translate(8.5, 25.5) rotate(-270) translate(-8.5, -25.5)"
            ></path>
          </g>
        </g>
      </svg>
    );
  }
}
